/**
 * Business utilities and helpers
 */

import { BUSINESS_STATUS } from "constants/businessConstants";

export const getStatusBadgeColor = (status: string) => {
  switch (status) {
    case BUSINESS_STATUS.APPROVED:
      return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400";
    case BUSINESS_STATUS.REJECTED:
      return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400";
    case BUSINESS_STATUS.PENDING:
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400";
  }
};

export const formatStatusLabel = (status: string): string => {
  return status.charAt(0).toUpperCase() + status.slice(1);
};

export const getStatusMessage = (status: string): string | null => {
  switch (status) {
    case BUSINESS_STATUS.PENDING:
      return "⏳ Your business listing is pending approval. Changes will be reviewed again.";
    case BUSINESS_STATUS.REJECTED:
      return "❌ Your business listing was rejected. Please update it and resubmit for approval.";
    case BUSINESS_STATUS.APPROVED:
      return "✅ Your business listing is approved and visible to the public.";
    default:
      return null;
  }
};

export const isStatusMessageWarning = (status: string): boolean => {
  return (
    status === BUSINESS_STATUS.PENDING || status === BUSINESS_STATUS.REJECTED
  );
};
